import React, { useEffect, useMemo, useRef, useState } from 'react'
import styled from "styled-components";

const MenuElement = styled.a`
  color: #666;
  margin-bottom: 4px;
  font-size: 14px;
  display: block;
  padding-left: 6px;
  border-left: 1px solid transparent;
  border-color: ${props => props.active ? "#ff513c" : "none" };
`

const SubMenuElement = styled(MenuElement)`
  padding-left: 20px;
`

const ProperMenuElement = ({type, ...props}) => {
  if (type == "title") {
    return ( <MenuElement {...props}/> )
  } else if(type == "subtitle") {
    return ( <SubMenuElement {...props}/>)
  }
}

const getParentStyleInfos = (ref) => {
  if (!ref.current) { return {} }
  const paddingLeft = parseInt(window.getComputedStyle(ref.current.parentElement, null).getPropertyValue('padding-left').replace('px', ''))
  const paddingRight = parseInt(window.getComputedStyle(ref.current.parentElement, null).getPropertyValue('padding-right').replace('px', ''))
  const width = ref.current.parentElement.scrollWidth
  return {paddingLeft, paddingRight, width}
}

const TableOfContent = ({list, blockRef, activeId, fixed=false}) => {
  const menuRef = useRef()
  const {paddingLeft, paddingRight, width} = getParentStyleInfos(menuRef)
  const fixedStyle = {
    position: "fixed",
    top: "30px",
    width: `${width - paddingLeft - paddingRight}px`
  }
  const relativeStyle = {
    position: "relative",
    width: "100%",
    top: "0",
  }

  const onClick = (e, id) => {
    const anchor = blockRef.current.querySelector(`a#${CSS.escape(id)}`)
    e.stopPropagation()
    e.preventDefault()
    anchor.scrollIntoView()
  }

  return(<div id="docMenu" ref={menuRef} style={fixed ? fixedStyle : relativeStyle}>
  { list.map((elt)=>(
      <ProperMenuElement
        type={elt.type}
        href=""
        key={elt.id}
        active={elt.id == activeId}
        onClick={(e)=>onClick(e, elt.id)}>
        {elt.title}
      </ProperMenuElement>
  ))}
  </div>)
}

export default TableOfContent